<style scoped>
::v-deep ::-webkit-scrollbar {
  width: 0;
  background: transparent;
}
</style>

<template>
  <v-navigation-drawer app permanent v-model="drawer" :mini-variant.sync="mini">
    <v-list>
      <v-list-item class="px-2">
        <v-img
          v-if="!mini && $vuetify.theme.dark"
          height="30"
          width="100"
          contain
          :src="require('../Images/maintel-logo-white-72DPI.png')"
        ></v-img>
        <v-img
          v-if="!mini && !$vuetify.theme.dark"
          height="30"
          width="100"
          contain
          :src="require('../Images/maintel-logo-coloured-72DPI.png')"
        ></v-img>

        <v-list-item-action @click.stop="mini = !mini">
          <span v-bind:class="{ 'ml-1': mini }" class="mr-3"
            ><a>
              <v-icon class="" aria-hidden="false"> mdi-menu </v-icon>
            </a></span
          >
        </v-list-item-action>
      </v-list-item>

      <!-- <v-divider id="menu-divider"></v-divider> -->
    </v-list>
    <v-divider></v-divider>
    <v-list
      nav
      class="ml-0"
      dense
      id="nav-list"
      v-bind:class="{ 'pl-0': mini }"
    >
      <v-list-item
        link
        class="pl-0"
        v-bind:class="{ 'no-pointer-even ts': mini }"
      >
<v-btn
  class=" pl-0"
  text
  href="https://portal.maintel.co.uk/"
  width="235px"
  v-bind:class="{ 'disabled-button': buttonClicked }"
>
  <v-col class="text-left" style="display: flex; align-items: center;">
    <v-img 
      style="display: inline-block; vertical-align: middle;"
      v-if="$vuetify.theme.dark"
      max-height="32"
      max-width="32"
      contain
      :src="require('../Images/icon-white-02.png')"
      alt="Home Icon"
    ></v-img>
    <v-img
      style="display: inline-block; vertical-align: middle;"
      v-if="!$vuetify.theme.dark"
      max-height="32"
      max-width="32"
      contain
      :src="require('../Images/icon-black-02.png')"
      alt="Home Icon"
    ></v-img>
    <span style="margin-left: 16px;">Home</span>
  </v-col>
</v-btn>

      </v-list-item>

      <v-list-item
        link
        class="pl-0"
        v-bind:class="{ 'no-pointer-even ts': mini }"
      >
        <v-btn
          class="pl-0 "
          @click="stateChange('/landing')"
          text
          width="235px"
          v-bind:class="{ 'disabled-button': buttonClicked }"
        >
          <v-col class="text-left" style="display: flex; align-items: center;">
            <v-img
              v-if="$vuetify.theme.dark"
              style="display: inline-block; vertical-align: middle;"
              max-height="32"
              max-width="32"
              contain
              :src="require('../Images/icon-white-33.png')"
              alt="Home Icon"
            ></v-img>
            <v-img
              v-if="!$vuetify.theme.dark"
              style="display: inline-block; vertical-align: middle;"
              max-height="32"
              max-width="32"
              contain
              :src="require('../Images/icon-black-33.png')"
              alt="Home Icon"
            ></v-img>
            <span style="margin-left: 16px;">Mobile Dashboard</span>
          </v-col>

          <v-icon> mdi-menu-down </v-icon>
        </v-btn>
      </v-list-item>

      <v-list-item
        link
        class="pl-0"
        v-bind:class="{ 'no-pointer-even ts': mini }"
        v-if="stateSelected == '/landing'"
      >
        <v-btn
          class=" pl-0 "
          @click="stateChange('/table/current_data_usage_line')"
          text
          width="235px"
          v-bind:class="{ 'disabled-button': buttonClicked }"
        >
          <v-col class="text-left ml-7">
            &nbsp;&nbsp;&nbsp; Current Data Usage
          </v-col>
        </v-btn>
      </v-list-item>
      <v-list-item
        link
        class="pl-0"
        v-bind:class="{ 'no-pointer-even ts': mini }"
        v-if="stateSelected == '/landing'"
      >
        <v-btn
          class=" pl-0 "
          @click="stateChange('/table/aggregate_cdr_summary_record')"
          text
          width="235px"
          v-bind:class="{ 'disabled-button': buttonClicked }"
        >
          <v-col class="text-left ml-7">
            &nbsp;&nbsp;&nbsp; Current OOB Spend
          </v-col>
        </v-btn>
      </v-list-item>
      <v-list-item
        link
        class="pl-0"
        v-bind:class="{ 'no-pointer-even ts': mini }"
        v-if="stateSelected == '/landing'"
      >
        <v-btn
          class=" pl-0 "
          @click="stateChange('/table/cdr_summary_record')"
          text
          width="235px"
          v-bind:class="{ 'disabled-button': buttonClicked }"
        >
          <v-col class="text-left ml-7">
            &nbsp;&nbsp;&nbsp; Current OOB Class
          </v-col>
        </v-btn>
      </v-list-item>

      <v-list-item
        link
        class="pl-0"
        v-bind:class="{ 'no-pointer-even ts': mini }"
        v-if="
          settings.roles.includes('mp_alert_readonly') ||
          settings.roles.includes(
            'mp_selfservice_alert_readonly'
          ) ||
          settings.roles.includes('mp_alertmanager') ||
          settings.roles.includes('mp_admin')
        "
      >
        <v-btn
          class=" pl-0 "
          @click="stateChange('/alerts')"
          text
          width="235px"
          v-bind:class="{ 'disabled-button': buttonClicked }"
        >
          <v-col class="text-left">
            <v-img
              v-if="$vuetify.theme.dark"
              style="display: inline-block; vertical-align: middle;"
              max-height="32"
              max-width="32"
              contain
              :src="require('../Images/icon-white-53.png')"
              alt="Home Icon"
            ></v-img>
            <v-img
              v-if="!$vuetify.theme.dark"
              style="display: inline-block; vertical-align: middle;"
              max-height="32"
              max-width="32"
              contain
              :src="require('../Images/icon-black-53.png')"
              alt="Home Icon"
            ></v-img>
            <span style="margin-left: 16px;">Alert Dashboard</span>

          </v-col>

          <v-icon> mdi-menu-down </v-icon>
        </v-btn>
      </v-list-item>

      <v-list-item
        link
        class="pl-0"
        v-bind:class="{ 'no-pointer-even ts': mini }"
        v-if="stateSelected == '/alerts' && ( settings.roles.includes('mp_admin') ||
            settings.roles.includes('mp_alertmanager'))"
      >
        <v-btn
          class=" pl-0 "
          @click="stateChange('/table/portal_alert')"
          text
          width="235px"
          v-bind:class="{ 'disabled-button': buttonClicked }"

        >
          <v-col class="text-left ml-7">
            &nbsp;&nbsp;&nbsp; Alert Rules Manager
          </v-col>
        </v-btn>
      </v-list-item>

      <v-list-item
        link
        class="pl-0"
        v-bind:class="{ 'no-pointer-even ts': mini }"
        v-if="stateSelected == '/alerts'"
      >
        <v-btn
          class=" pl-0 "
          @click="stateChange('/table/alert_record')"
          text
          width="235px"
          v-bind:class="{ 'disabled-button': buttonClicked }"
        >
          <v-col class="text-left ml-7">
            &nbsp;&nbsp;&nbsp; Alert History
          </v-col>
        </v-btn>
      </v-list-item>

      <v-list-item
        link
        class="pl-0"
        v-bind:class="{ 'no-pointer-even ts': mini }"
        v-if="stateSelected == '/alerts'"
      >
        <v-btn
          class=" pl-0 "
          @click="stateChange('/table/delete_alert_audit_line')"
          text
          width="235px"
          v-bind:class="{ 'disabled-button': buttonClicked }"
        >
          <v-col class="text-left ml-7">
            &nbsp;&nbsp;&nbsp; Alert Delete Audit
          </v-col>
        </v-btn>
      </v-list-item>

      <v-list-item
        link
        class="pl-0"
        v-bind:class="{ 'no-pointer-even ts': mini }"
        v-if="stateSelected == '/alerts'"
      >
        <v-btn
          class=" pl-0 "
          @click="stateChange('/table/read_alert_audit_line')"
          text
          width="235px"
          v-bind:class="{ 'disabled-button': buttonClicked }"
        >
          <v-col class="text-left ml-7">
            &nbsp;&nbsp;&nbsp; Alert Read Audit
          </v-col>
        </v-btn>
      </v-list-item>

      <v-list-item
        link
        class="pl-0"
        v-bind:class="{ 'no-pointer-even ts': mini }"
        @click="stateSelected = 'invoices'"
      >
        <v-btn
          class=" pl-0"
          text
          width="235px"
          v-bind:class="{ 'disabled-button': buttonClicked }"
        >
          <v-col class="text-left" style="display: flex; align-items: center;">
            <v-img
              v-if="$vuetify.theme.dark"
              style="display: inline-block; vertical-align: middle;"
              max-height="32"
              max-width="32"
              contain
              :src="require('../Images/icon-white-invoice.png')"
              alt="Home Icon"
            ></v-img>
            <v-img
              v-if="!$vuetify.theme.dark"
              style="display: inline-block; vertical-align: middle;"
              max-height="32"
              max-width="32"
              contain
              :src="require('../Images/icon-black-invoice.png')"
              alt="Home Icon"
            ></v-img>
            <span style="margin-left: 16px;">Invoices</span>

          </v-col>

          <v-icon> mdi-menu-down </v-icon>
        </v-btn>
      </v-list-item>

      <v-list-item
        link
        class="pl-0"
        v-bind:class="{ 'no-pointer-even ts': mini }"
        v-if="stateSelected == 'invoices'"
      >
        <v-btn
          class=" pl-0 "
          @click="stateChange('/table/aggregate_invoice_line')"
          text
          width="235px"
          v-bind:class="{ 'disabled-button': buttonClicked }"
        >
          <v-col class="text-left ml-7">
            &nbsp;&nbsp;&nbsp; Invoice Summary
          </v-col>
        </v-btn>
      </v-list-item>

      <v-list-item
        link
        class="pl-0"
        v-bind:class="{ 'no-pointer-even ts': mini }"
        v-if="stateSelected == 'invoices'"
      >
        <v-btn
          class=" pl-0 "
          @click="stateChange('/table/invoice_line')"
          text
          width="235px"
          v-bind:class="{ 'disabled-button': buttonClicked }"
        >
          <v-col class="text-left ml-7">
            &nbsp;&nbsp;&nbsp; Invoice Itemisation
          </v-col>
        </v-btn>
      </v-list-item>

      <v-list-item
        link
        class="pl-0"
        v-bind:class="{ 'no-pointer-even ts': mini }"
        @click="stateSelected = 'usage'"
      >
        <v-btn
          class=" pl-0 "
          text
          width="235px"
          v-bind:class="{ 'disabled-button': buttonClicked }"
        >
          <v-col class="text-left" style="display: flex; align-items: center;">
            <v-img
              v-if="$vuetify.theme.dark"
              style="display: inline-block; vertical-align: middle;"
              max-height="32"
              max-width="32"
              contain
              :src="require('../Images/icon-white-229.png')"
              alt="Home Icon"
            ></v-img>
            <v-img
              v-if="!$vuetify.theme.dark"
              style="display: inline-block; vertical-align: middle;"
              max-height="32"
              max-width="32"
              contain
              :src="require('../Images/icon-black-229.png')"
              alt="Home Icon"
            ></v-img>
            <span style="margin-left: 16px;">Usage Analysis</span>
          </v-col>

          <v-icon> mdi-menu-down </v-icon>
        </v-btn>
      </v-list-item>

      <v-list-item
        link
        class="pl-0"
        v-bind:class="{ 'no-pointer-even ts': mini }"
        v-if="stateSelected == 'usage'"
      >
        <v-btn
          class=" pl-0 "
          @click="stateChange('/table/aggregate_bundle_line')"
          text
          width="235px"
          v-bind:class="{ 'disabled-button': buttonClicked }"
        >
          <v-col class="text-left ml-7">
            &nbsp;&nbsp;&nbsp; Bundle Summary
          </v-col>
        </v-btn>
      </v-list-item>

      <v-list-item
        link
        class="pl-0"
        v-bind:class="{ 'no-pointer-even ts': mini }"
        v-if="stateSelected == 'usage'"
      >
        <v-btn
          class=" pl-0 "
          @click="stateChange('/table/bundle_line')"
          text
          width="235px"
          v-bind:class="{ 'disabled-button': buttonClicked }"
        >
          <v-col class="text-left ml-7">
            &nbsp;&nbsp;&nbsp; Bundle Utilisation
          </v-col>
        </v-btn>
      </v-list-item>

      <v-list-item
        link
        class="pl-0"
        v-bind:class="{ 'no-pointer-even ts': mini }"
        v-if="stateSelected == 'usage'"
      >
        <v-btn
          class=" pl-0 "
          @click="stateChange('/table/call_class_line')"
          text
          width="235px"
          v-bind:class="{ 'disabled-button': buttonClicked }"
        >
          <v-col class="text-left ml-7"> &nbsp;&nbsp;&nbsp; Call Class </v-col>
        </v-btn>
      </v-list-item>

      <v-list-item
        link
        class="pl-0"
        v-bind:class="{ 'no-pointer-even ts': mini }"
        @click="stateSelected = 'user'"
      >
        <v-btn
          class=" pl-0 "
          text
          width="235px"
          v-bind:class="{ 'disabled-button': buttonClicked }"
        >
          <v-col class="text-left" style="display: flex; align-items: center;">
            <v-img
              v-if="$vuetify.theme.dark"
              style="display: inline-block; vertical-align: middle;"
              max-height="32"
              max-width="32"
              contain
              :src="require('../Images/icon-white-167.png')"
              alt="Home Icon"
            ></v-img>
            <v-img
              v-if="!$vuetify.theme.dark"
              style="display: inline-block; vertical-align: middle;"
              max-height="32"
              max-width="32"
              contain
              :src="require('../Images/icon-black-167.png')"
              alt="Home Icon"
            ></v-img>
            &nbsp;&nbsp;&nbsp; User Management
          </v-col>

          <v-icon> mdi-menu-down </v-icon>
        </v-btn>
      </v-list-item>

      <v-list-item
        link
        class="pl-0"
        v-bind:class="{ 'no-pointer-even ts': mini }"
      >
        <v-btn
          class=" pl-0 "
          @click="stateChange('/table/data_report_line')"
          text
          width="235px"
          v-bind:class="{ 'disabled-button': buttonClicked }"
          v-if="stateSelected == 'user'"
        >
          <v-col class="text-left ml-7">
            &nbsp;&nbsp;&nbsp; Subscriptions
          </v-col>
        </v-btn>
      </v-list-item>
      <v-list-item
        link
        class="pl-0"
        v-bind:class="{ 'no-pointer-even ts': mini }"
        v-if="stateSelected == 'user'"
      >
        <v-btn
          class=" pl-0 "
          @click="stateChange('/table/non_cc_bar_line')"
          text
          width="235px"
          v-bind:class="{ 'disabled-button': buttonClicked }"
        >
          <v-col class="text-left ml-7">
            &nbsp;&nbsp;&nbsp; Service Bars
          </v-col>
        </v-btn>
      </v-list-item>

      <v-list-item
        link
        class="pl-0"
        v-bind:class="{ 'no-pointer-even ts': mini }"
        v-if="stateSelected == 'user'"
      >
        <v-btn
          class=" pl-0 "
          @click="stateChange('/table/service_report_line')"
          text
          width="235px"
          v-bind:class="{ 'disabled-button': buttonClicked }"
        >
          <v-col class="text-left ml-7">
            &nbsp;&nbsp;&nbsp; Subscription Services
          </v-col>
        </v-btn>
      </v-list-item>

      <v-list-item
        link
        class="pl-0"
        v-bind:class="{ 'no-pointer-even ts': mini }"
        v-if="stateSelected == 'user'"
      >
        <v-btn
          class=" pl-0 "
          @click="stateChange('/table/diary_events_line')"
          text
          width="235px"
          v-bind:class="{ 'disabled-button': buttonClicked }"
        >
          <v-col class="text-left ml-7">
            &nbsp;&nbsp;&nbsp; Service Change Log
          </v-col>
        </v-btn>
      </v-list-item>

      <v-list-item
        link
        class="pl-0"
        v-bind:class="{ 'no-pointer-even ts': mini }"
        v-if="stateSelected == 'user'"
      >
        <v-btn
          class=" pl-0 "
          @click="stateChange('/table/service_response_line')"
          text
          width="235px"
          v-bind:class="{ 'disabled-button': buttonClicked }"
        >
          <v-col class="text-left ml-7">
            &nbsp;&nbsp;&nbsp; Self Serve Log
          </v-col>
        </v-btn>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  props: {
    options: Object,
    settings: Object,
  },
  data() {
    return {
      drawer: false,
      mini: false,
      topLevelStates: ["/landing", "/alerts", "invoices", "usage", "user"],
      active: true,
      hideExpandedMenuOptions: false,
      buttonClicked: false,
      unreadAlertCount: 0,
      stateSelected: "",
    };
  },
  methods: {
    toggleActive() {
      this.active = !this.active;
    },
    stateChange(state) {
      this.buttonClicked = true;
      var self = this;

      if (this.topLevelStates.includes(state)) {
        this.stateSelected = state;
      }

      setTimeout(function () {
        self.buttonClicked = false;
      }, 500);

      this.$router.push({ path: state });
    },
  },
};
</script>